import { render, staticRenderFns } from "./CropFertilizers.vue?vue&type=template&id=f5c50d02&"
import script from "./CropFertilizers.vue?vue&type=script&lang=js&"
export * from "./CropFertilizers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports